export function datajs(name, ctx = document) {
	let elements = ctx.querySelectorAll('[data-js~="' + name + '"]');

	if (elements.length === 1) {
		return elements[0];
	}

	return elements;
}
